import { COLORS, marginLg, stickyTopOffset } from 'assets/styled';
import styled, { css } from 'styled-components';
import { HAS_IMAGES_BREAKPOINT } from 'utils/hooks/useHasImages';

interface StyledProps {
  hasValue: boolean;
  showBorder: boolean;
  hasPrice: boolean;
  hasImages: boolean;
  opacityIndex: number;
  opacityCoefficient: number;
  hasRedStar?: boolean;
  isSkeleton?: boolean;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: center;
  max-width: 50%;
  width: 100%;
  height: 100%;

  ${(props: StyledProps) =>
    !props.hasImages &&
    css`
      width: 100%;
      max-width: 100%;
    `};

  @media screen and (max-width: ${HAS_IMAGES_BREAKPOINT}px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const FormContainer = styled.div``;

export const LabelsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20rem;
  gap: 10rem;

  /*
   * Button pads its own wrapper whenever the label has an icon; this row does
   * its own spacing, so the extra padding would only widen the gaps. Doubled
   * class to outrank that rule's :has() selector.
   */
  && > div {
    padding: 0;
  }

  /*
   * Follows the form while scrolling. With no labels rendered (e.g. resolving a
   * quotation line on a model without BOM items or specs) it stays a plain
   * spacer - a sticky empty white strip would just cover the questions.
   * The negative top margin cancels the padding, so the labels sit exactly
   * where they did before and only get breathing room once stuck.
   * z-index: above question rows, below FormImages (9) and the fixed bars.
   */
  &:not(:empty) {
    position: sticky;
    top: ${stickyTopOffset};
    z-index: 8;
    margin-top: -10rem;
    margin-bottom: 10rem;
    padding: 10rem 0;
    background-color: ${COLORS.WHITE};
  }
`;

export const ModelNotFoundLabel = styled.label`
  text-align: center;
  width: 100%;
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 400;
  margin-bottom: ${marginLg};
`;

// Separates the view actions (specs, BOM) from the destructive one (clear).
export const LabelsDivider = styled.div`
  width: 1rem;
  height: 24rem;
  background-color: ${COLORS.BORDER};
`;
